import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  TimeInput,
  Input,
  DatePicker,
  Textarea,
  Select,
  SelectItem,
} from "@nextui-org/react";
import "./ModelForm.css";

const IncidentIntegrationForm = () => {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  
    navigate("/admin/incidentintegration");
  };

  return (
    <div className="main-inner-wrapper leavemenu-wrapper">
      <h1 className="incident-report-heading">Add Incident Integration Details</h1>
      <div className="px-4">
        <div className="leave-apply__wrapper p-4 bg-white dark:bg-neutral-800 border border-gray-300 dark:border-gray-500 rounded-xl">
          <div className="form-container">
            <form onSubmit={handleSubmit}>
              <div>
                <div className="form-row">
                  <Input
                    variant="bordered"
                    label="Incident Report Number"
                    defaultValue="INCOO1"
                    readOnly
                  />
                  <Select label="Department" className="max-w-full" variant="bordered">
                    <SelectItem key="Manufacturing" value="Manufacturing">
                      Manufacturing
                    </SelectItem>
                    <SelectItem key="pharmaceutical" value="pharmaceutical">
                      pharmaceutical
                    </SelectItem>
                  </Select>
                </div>
                <div className="form-row">
                  <DatePicker variant="bordered" label="Date" />
                  <TimeInput variant="bordered" label="Time" />
                </div>
                <div className="form-row">
                  <Select
                    label="Responsible Employee"
                    className="max-w-full"
                    variant="bordered"
                    multiple
                  >
                    <SelectItem key="JOHN" value="JOHN">
                      JOHN
                    </SelectItem>
                    <SelectItem key="SMITH" value="SMITH">
                      SMITH
                    </SelectItem>
                  </Select>
                  <Select
                    label="Reported By"
                    className="max-w-full"
                    variant="bordered"
                    multiple
                  >
                    <SelectItem key="OLIVIA" value="OLIVIA">
                      OLIVIA
                    </SelectItem>
                  </Select>
                </div>
                <div className="form-row">
                  <Select
                    label="Type Of Incident"
                    className="max-w-full"
                    variant="bordered"
                  >
                    <SelectItem
                      key="Defibrillator Mishandling"
                      value="Defibrillator Mishandling"
                    >
                      Defibrillator Mishandling
                    </SelectItem>
                    <SelectItem
                      key="Medication Dosage Error"
                      value="Medication Dosage Error"
                    >
                      Medication Dosage Error
                    </SelectItem>
                    <SelectItem
                      key="Contaminated Supplies Issue"
                      value="Contaminated Supplies Issue"
                    >
                      Contaminated Supplies Issue
                    </SelectItem>
                    <SelectItem
                      key="Handoff Miscommunication"
                      value="Handoff Miscommunication"
                    >
                      Handoff Miscommunication
                    </SelectItem>
                  </Select>
                  <Input
                    variant="bordered"
                    label="Attachment"
                    type="file"
                    style={{ opacity: "0" }}
                  />
                </div>
                <div className="form-row">
                  <Textarea
                    variant="bordered"
                    label="Detail Description"
                    defaultValue="Mislabeling of products or raw materials."
                  />
                  <Textarea
                    variant="bordered"
                    label="Damage Report"
                    defaultValue="Patient had experienced harmful side effects and adverse reactions."
                  />
                </div>

                <div className="flex justify-center items-center gap-4" >
                  <Button className="incidentSubmitBtn" type="submit">
                    Submit
                  </Button>
                  <Button color="danger" variant="flat" onClick={() => navigate('/admin/incidentintegration')}>
                    Cancel
                  </Button>
                </div>

              </div> </form>

          </div>
        </div>
      </div>
    </div>
  );
};

export default IncidentIntegrationForm;
